import { Button, Card, Grid, Typography } from '@mui/material'

import { IStepAccountRespDto } from 'src/types'
import { useRemoveAccountStepsConnections } from 'src/hooks'
import { useStyles } from 'src/components/impacts-library/impacts-library-list/styles'
import { SPACES } from 'src/constants'
import { HelperWrapper } from 'src/components/helper-wrapper'
import { useApproveStepAccountConnectionManually } from 'src/hooks/steps/use-approve-step-account-connection-manually'

interface IItemsListProps {
  items: IStepAccountRespDto[]
}

const ItemsList = ({ items }: IItemsListProps) => {
  const classes = useStyles()
  const { mutate: disconnect, isLoading } = useRemoveAccountStepsConnections(true)
  const { mutate: approveConnection, isLoading: isApproveConnectionLoading } =
    useApproveStepAccountConnectionManually(true)

  return (
    <Grid container className={classes.itemsListWrapper}>
      {items?.map((item) => (
        <Grid key={item.id} item>
          <Card style={{ paddingLeft: SPACES.s }} className={classes.itemWrapper}>
            <div className={classes.itemContent}>
              <div>
                <Typography className={classes.itemName} component="h4">
                  {item.step?.name}
                </Typography>
              </div>
              <div>
                <Button
                  size="small"
                  type="button"
                  variant={
                    item.account_disconnected ||
                    (item.account_approved && !item.account_disconnected)
                      ? 'outlined'
                      : 'contained'
                  }
                  className={`${classes.impactsLibraryButton} ${classes.selectImpactButton} ${
                    item.account_disconnected ||
                    (item.account_approved && !item.account_disconnected)
                      ? classes.buttonOutlined
                      : ''
                  } ${
                    item.account_approved && !item.account_disconnected
                      ? classes.buttonDissconect
                      : ''
                  }`}
                  disabled={isLoading || isApproveConnectionLoading}
                  onClick={() => {
                    if (item.account_approved && !item.account_disconnected) {
                      disconnect({
                        stepId: item.step?.id || '',
                        accountId: item.account?.id || '',
                      })
                    } else {
                      approveConnection(item.id)
                    }
                  }}
                >
                  <HelperWrapper
                    t={
                      item.account_disconnected
                        ? 'reconnect-button-text'
                        : item.account_approved
                        ? 'disconnect-button-text'
                        : 'approve-button-text'
                    }
                    isColorInherited
                  />
                </Button>
              </div>
            </div>
          </Card>
        </Grid>
      ))}
    </Grid>
  )
}

export { ItemsList }
